
import React, { useEffect, useState } from 'react'

import DocumentPdfIcon from '../../../SvgImages/Document/DocumentPdfIcon'
import DocumentExcelIcon from '../../../SvgImages/Document/DocumentExcelIcon'
import DocumentWordIcon from '../../../SvgImages/Document/DocumentWordIcon'
import DocumentImageIcon from '../../../SvgImages/Document/DocumentImageIcon'
import DocumentPowerpointIcon from '../../../SvgImages/Document/DocumentPowerpointIcon'
import DocumentCsvIcon from '../../../SvgImages/Document/DocumentCsvIcon'
import DocumentAudioIcon from '../../../SvgImages/Document/DocumentAudioIcon'
import DocumentVideoIcon from '../../../SvgImages/Document/DocumentVideoIcon'
import DocumentZipIcon from '../../../SvgImages/Document/DocumentZipIcon'

import './DocumentIcon.scss'

interface Props {
  mimeType: string
}

const DocumentIcon = ({ mimeType }: Props) => {

  const validMimeTypes = [
    'application/pdf',
    'application/zip',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/csv',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/svg+xml',
    'audio/mpeg',
    'audio/ogg',
    'video/mp4',
    'video/ogg',
    'video/webm',
  ]

  const [ type, setType ] = useState('')

  useEffect(() => {

    const getDocumentIcon = () => {

      switch (mimeType) {
        case 'application/pdf':
          setType('pdf')
          break
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          setType('word')
          break
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          setType('excel')
          break
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          setType('powerpoint')
          break
        case 'text/csv':
          setType('csv')
          break
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/svg+xml':
          setType('image')
          break
        case 'audio/mpeg':
          setType('audio')
          break
        case 'audio/ogg':
          setType('audio')
          break
        case 'video/mp4':
          setType('video')
          break
        case 'video/ogg':
          setType('video')
          break
        case 'video/webm':
          setType('video')
          break
        case 'application/zip':
          setType('zip')
          break
        default:
          setType('unknown')
      }
    }

    if (!mimeType) return

    if (validMimeTypes.includes(mimeType)) {

      getDocumentIcon()
    }
  }, [mimeType])

  return (
    <div className={`document-icon ${type}`}>
      {type === 'pdf' && <DocumentPdfIcon width={24} height={24} />}
      {type === 'word' && <DocumentWordIcon width={24} height={24} />}
      {type === 'excel' && <DocumentExcelIcon width={24} height={24} />}
      {type === 'powerpoint' && <DocumentPowerpointIcon width={24} height={24} />}
      {type === 'csv' && <DocumentCsvIcon width={24} height={24} />}
      {type === 'image' && <DocumentImageIcon width={24} height={24} />}
      {type === 'audio' && <DocumentAudioIcon width={24} height={24} />}
      {type === 'video' && <DocumentVideoIcon width={24} height={24} />}
      {type === 'zip' && <DocumentZipIcon width={24} height={24} />}
      {type === 'unknown' && <DocumentPdfIcon width={24} height={24} />}
    </div>
  )
}

export default DocumentIcon
